import { connect } from 'react-redux';
import TinyPlayerQuery from '../views/tiny/TinyPlayerQuery';

function mapStateToProps(state, ownProps) {
  return {};
}

const mapDispatchToProps = (dispatch) => ({});

const TinyPlayerQueryContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TinyPlayerQuery);

export default TinyPlayerQueryContainer;


